import { Observable } from 'rxjs';
import { GenericService } from 'services/genericService';
import {
	createLoyaltyGroup,
	getLoyaltyGroups,
	getLoyaltyGroupDetails,
	updateLoyaltyGroup,
	deleteLoyaltyGroup,
	addSubscription,
	getGroupSubscriptions,
	getSubscriptionDetails,
	unsubscribeSubscription,
	unsubscribeNumber,
} from 'utils/api/queries/microApi';

import * as payloads from 'utils/api/payloads/microApi';
import { LoyaltyGroups } from 'utils/api/models/prepaidLoyalty/loyaltyGroups';
import { CreateUpdateLoyaltyResponse } from 'utils/api/models/prepaidLoyalty/createUpdateLoyaltyResponse';
import { LoyaltyGroupDetails } from 'utils/api/models/prepaidLoyalty/loyaltyGroupDetails';
import { GroupSubscriptions } from 'utils/api/models/prepaidLoyalty/groupSubscriptions';
import { SubscriptionDetails } from 'utils/api/models/prepaidLoyalty/subscriptionDetails';
import { finalize } from 'rxjs/operators';
import invalidateCache from 'utils/api/invalidateCache';

export class LoyaltyGroupService extends GenericService {
	static createLoyaltyGroup(data: payloads.CreateUpdateLoyaltyGroupData): Observable<CreateUpdateLoyaltyResponse> {
		return createLoyaltyGroup(data)
			.withErrorHandling()
			.call();
	}

	static getLoyaltyGroups(upId: number | null): Observable<LoyaltyGroups> {
		return getLoyaltyGroups(upId)
			.withErrorHandling()
			.call();
	}

	static getLoyaltyGroupDetails(groupId: number): Observable<LoyaltyGroupDetails> {
		return getLoyaltyGroupDetails(groupId)
			.withErrorHandling()
			.call();
	}

	static getGroupSubscriptions(groupId: number): Observable<GroupSubscriptions> {
		return getGroupSubscriptions(groupId)
			.withErrorHandling()
			.call();
	}

	static getSubscriptionDetails(subscriptionId: number): Observable<SubscriptionDetails> {
		return getSubscriptionDetails(subscriptionId)
			.withErrorHandling()
			.call();
	}

	static addSubscription(data: payloads.AddSubscription): Observable<any> {
		return addSubscription(data)
			.withErrorHandling()
			.call()
			.pipe(finalize(() => invalidateCache(['getAddonsTopUpsSubscriptions', 'getGroupSubscriptions'], true)));
	}

	static updateLoyaltyGroup(
		groupId: number,
		data: payloads.CreateUpdateLoyaltyGroupData
	): Observable<CreateUpdateLoyaltyResponse> {
		return updateLoyaltyGroup(groupId, data)
			.withErrorHandling()
			.call();
	}

	static deleteLoyaltyGroup(groupId: number) {
		return deleteLoyaltyGroup(groupId).call();
	}

	static unsubscribeSubscription(subscriptionId: number) {
		return unsubscribeSubscription(subscriptionId)
			.withErrorHandling()
			.call();
	}

	static unsubscribeNumber(data: payloads.UnsubscribeNumber) {
		return unsubscribeNumber(data)
			.withErrorHandling()
			.call();
	}
}
